import {actionsCode} from "@/assets/meq-docs/userActionCodes.json";

function getUserActionInfo(code){
    if(!code){
        return false;
    }
    return actionsCode.find(action => action.code === code);
}

export default getUserActionInfo;